export class FilterApi {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    async fetchResults(params) {
        var _a;
        const url = params.toString() ? `${this.baseUrl}&${params.toString()}` : this.baseUrl;
        const res = await fetch(url);
        if (!res.ok)
            throw new Error('Response not ok');
        const data = await res.json();
        return (_a = data.results) !== null && _a !== void 0 ? _a : [];
    }
}
